import i18next from 'i18next';

i18next.addResources('es', 'mapToggle', {
  showMap: 'Ver mapa',
  showList: 'Ver lista'
});

i18next.addResources('en', 'mapToggle', {
  showMap: 'View map',
  showList: 'View list'
});

i18next.addResources('pt', 'mapToggle', {
  showMap: 'Ver mapa',
  showList: 'Ver lista'
});
